function getConfigCompoment () { return 'CSVFactory' }
function getStandardAttributes () { return null }

export default {
  getConfigCompoment,
  getStandardAttributes
}
